import type { IconSvgObject } from './types';

const Building03Icon: IconSvgObject = [
  ["path", { d: "M16 10L19.7428 11.4971C20.5021 11.8008 21 12.5363 21 13.3541V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 9L11 9M8 13H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5 22V18C11.5 17.4477 11.0523 17 10.5 17H8.5C7.94772 17 7.5 17.4477 7.5 18V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M1 22H23", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M3.00024 22L3 2.99993C3.00038 2.34704 3.61614 1.86962 4.24855 2.03189L15.2376 4.85166C15.6798 4.96514 15.989 5.36373 15.989 5.82028L16.0002 21.9004", stroke: "currentColor", strokeWidth: "1.5", key: "4" }]
];

export default Building03Icon;
